import { Initialize } from '../actions';
import { ConsentActions, ConsentActionType } from '../actions/consentActions';
import { LoginAndRegisterActions, LoginAndRegisterActionType } from '../actions/loginAndRegisterActions';
import { ResetPasswordActions, ResetPasswordActionType } from '../actions/resetPasswordActions';
import { Mode } from '../models/commonEnums';
import { ClientInfo, RedirectAttrs } from '../models/commonModels';
import { getUrlVars } from '../utils';

const initialMode = (): Mode => {
    const queryParams = getUrlVars(window.location.search);
    // Make pro app look like b2b_desktop, but w.o. sso:
    if (queryParams.client_id == `6c39b271-9361-407f-9317-1c302bcd6c3a`) {
        return Mode.pro_app;
    } else {
        return Mode.b2b_desktop;
    }
};

export type UserState = {
    email: string;
    mode: Mode;
    redirectAttrs: RedirectAttrs;
    clientInfo?: ClientInfo;
};
const initialState: UserState = {
    email: '',
    mode: initialMode(), // Mode.b2b_desktop,
    redirectAttrs: {},
    clientInfo: undefined,
};

type ActionTypes = LoginAndRegisterActions | ResetPasswordActions | ConsentActions | Initialize;

export default (state = initialState, action: ActionTypes): UserState => {
    switch (action.type) {
        case ResetPasswordActionType.ConfirmResetPasswordSuccess:
        case LoginAndRegisterActionType.SetUserEmail:
            return {
                ...state,
                email: action.email,
            };
        case LoginAndRegisterActionType.SetMode:
            return {
                ...state,
                mode: action.mode,
            };
        case ConsentActionType.SetClientInfo:
            return {
                ...state,
                clientInfo: action.clientInfo,
            };
        case ConsentActionType.SetRedirectAttrs:
            return {
                ...state,
                redirectAttrs: action.redirectAttrs,
            };
        default:
            return state;
    }
};
